import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 mt-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-7 col-xxl-5" }
const _hoisted_4 = { class: "col-lg-5 col-xxl-7" }
const _hoisted_5 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomRouteFormTemplateComponent = _resolveComponent("CustomRouteFormTemplateComponent")!
  const _component_CustomRouteMapTemplateComponent = _resolveComponent("CustomRouteMapTemplateComponent")!
  const _component_VehicleSelectWrapperComponent = _resolveComponent("VehicleSelectWrapperComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CustomRouteFormTemplateComponent, {
          "total-distance": _ctx.store.state.orderTrueDriver.totalDistance,
          "total-duration": _ctx.store.state.orderTrueDriver.totalDuration,
          price: _ctx.store.state.orderTrueDriver.price,
          message: _ctx.message,
          backendValidationErrors: _ctx.backendValidationErrors,
          loading: _ctx.loading,
          isOrderable: _ctx.isOrderable,
          onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubmit($event)))
        }, null, 8, ["total-distance", "total-duration", "price", "message", "backendValidationErrors", "loading", "isOrderable"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CustomRouteMapTemplateComponent)
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      "show-title": false,
      "id-data": 'selectVehicleModal'
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_VehicleSelectWrapperComponent, {
            "is-main-modal": false,
            "filtered-vehicles": _ctx.vehiclesData
          }, null, 8, ["filtered-vehicles"])
        ])
      ]),
      _: 1
    })
  ]))
}